import {
  Component,
  OnInit,
  ViewChild
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { DialogService } from "../../Shared/dialog.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { LmsService } from "../services/lms.service";
declare var $: any;

@Component({
    selector: "app-lms-enach-response",
    templateUrl: "./lms-enach-response.component.html",
    styleUrls: ["./lms-enach-response.component.scss"],
    standalone: false
})
export class LmsEnachResponseComponent implements OnInit {
  currentUser: any;
  showSpinner: boolean = false;
  loading: boolean = false;

  PostDateFrom: any;
  PostDateTo: any;
  LoanAcNo: any;
  IsHideUpdate: any = true;
  dataSource: any;
  displayedColumns: string[] = [];
  JsonData: any[] = [];
  dialogreturn: any;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private dialog: DialogService,
    private lmsService: LmsService,
    private MasterService: MasterService
  ) { }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("E-Nach Response");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));

    this.displayedColumns = [
      "Loan_Id",
      "LoanAcNo",
      "CustomerName",
      "Loan_Date",
      "Identifier",
      "AccountName",
      "DueDate",
      "EMI_Amount",
      "CustomerBankname",
    ];
  }

  onSearchENachResponse() {
    this.showSpinner = true;
    this.lmsService
      .ENach_Pending_Status({
        PostDateFrom: this.PostDateFrom,
        PostDateTo: this.PostDateTo,
        LoanAcNo: this.LoanAcNo,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        console.log("res", res);
        if (res.length > 0) {
          this.JsonData = JSON.parse(JSON.stringify(res));
          this.dataSource = new MatTableDataSource(this.JsonData);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.dataSource = null;
        }
        this.showSpinner = false;
      });
  }

  public calculateTotal() {
    if (this.dataSource != null) {
      let sum = 0;
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        sum += Number(this.dataSource.filteredData[i]["EMI_Amount"]);
      }
      return sum;
    }
    return 0;
  }

  TransactionVerification() {
    this.showSpinner = true;
    this.IsHideUpdate = false;
    this.lmsService.ENach_GetTransactionVerification().subscribe((res: any) => {
      if (res[0]?.CODE == 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
        this.showSpinner = false;
        this.IsHideUpdate = true;
        this.onSearchENachResponse();
      } else {
        this.showSpinner = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0]?.MSG,
          ...this.configSuccess,
        });
      }
    });
  }
}
